function cov_1nom9xj7dw() {
  var path = "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/colors.ts";
  var hash = "c19e97f7c5f867aa760dba9a7bcf766b786d24a3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/theme/eero/foundations/colors.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 60
        },
        end: {
          line: 13,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 71
        },
        end: {
          line: 18,
          column: 1
        }
      },
      "2": {
        start: {
          line: 20,
          column: 66
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "3": {
        start: {
          line: 30,
          column: 76
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "4": {
        start: {
          line: 41,
          column: 64
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "5": {
        start: {
          line: 47,
          column: 75
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "6": {
        start: {
          line: 54,
          column: 56
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "7": {
        start: {
          line: 63,
          column: 72
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "8": {
        start: {
          line: 69,
          column: 31
        },
        end: {
          line: 73,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c19e97f7c5f867aa760dba9a7bcf766b786d24a3"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1nom9xj7dw = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_1nom9xj7dw();

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Design System
export var brand = (cov_1nom9xj7dw().s[0]++, {
  brand50: '#0D76D6',
  brand40: '#3E8DD8',
  brand30: '#49A3E0'
});
export var brandDescriptors = (cov_1nom9xj7dw().s[1]++, {
  brand50: 'Primary color for the brand',
  brand40: 'Used for link hover states',
  brand30: 'Used for link active states'
});
export var neutrals = (cov_1nom9xj7dw().s[2]++, {
  neutrals100: '#222222',
  neutrals90: '#6E6E6E',
  neutrals70: '#949494',
  neutrals40: '#DEDEDE',
  neutrals30: '#E9E9E9',
  neutrals20: '#F2F2F2',
  neutrals10: '#FAFAFA',
  neutrals0: '#FFFFFF'
});
export var neutralDescriptors = (cov_1nom9xj7dw().s[3]++, {
  neutrals100: 'body copy, acccents, buttons',
  neutrals90: 'subheaders, subtext, icons',
  neutrals70: 'subheaders, subtext, icons',
  neutrals40: 'outlines on text fields and buttons',
  neutrals30: 'dividers',
  neutrals20: 'hover state on buttons',
  neutrals10: 'background',
  neutrals0: ''
});
export var accents = (cov_1nom9xj7dw().s[4]++, {
  red50: '#C34143',
  green50: '#007F5E',
  terracotta50: '#FF896F',
  blue30: '#EEF4FA'
});
export var accentsDescriptors = (cov_1nom9xj7dw().s[5]++, {
  red50: 'error messaging',
  green50: 'accents, elements',
  terracotta50: 'favorite heart, jewel icon',
  blue30: 'alerts, highlights'
});
export var colors = (cov_1nom9xj7dw().s[6]++, _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, brand), neutrals), accents), {}, {
  transparent: 'transparent',
  currentColor: 'currentColor'
}));
export var colorDescriptors = (cov_1nom9xj7dw().s[7]++, _objectSpread(_objectSpread(_objectSpread({}, brandDescriptors), neutralDescriptors), accentsDescriptors));
export var ColorSchemeKeys = (cov_1nom9xj7dw().s[8]++, [].concat(_toConsumableArray(Object.keys(brand)), _toConsumableArray(Object.keys(neutrals)), _toConsumableArray(Object.keys(accents))));
export default colors;